require.context('../images', true)
require("@rails/ujs").start()
require("turbolinks").start()
require("../stylesheets/application.scss");
require("bootstrap/js/src/collapse");
require("bootstrap/js/src/dropdown");
require("owl.carousel/dist/assets/owl.carousel.css")

import $ from 'jquery';
global.$ = jQuery;
